//#region src/TransientNetworkError.ts
/**
* A typed error for transient network failures that should be retried with
* exponential backoff. Throw this error from your RemoteApi implementation
* when encountering temporary network issues like timeouts, rate limits, or
* server errors.
*
* The SyncEngine will automatically retry operations that throw this error
* using exponential backoff with jitter.
*/
var TransientNetworkError = class extends Error {
	constructor(message) {
		super(message ?? "Transient network error occurred");
		this.name = "TransientNetworkError";
	}
};

//#endregion
export { TransientNetworkError };